<template>
  <div class="menu-item-info">
    <h2 class="menu-item-info__title">{{ menuItem?.name }}</h2>
    <p v-if="isDescriptionVisible" class="menu-item-info__description m-b-0">
      {{ menuItem?.description }}
    </p>
    <p class="menu-item-info__price">
      {{ prependUsdSign(itemPrice)
      }}<span v-if="displayCalories" class="menu-item-info__calories">{{ menuItem.calories }} {{ caloriesLabel }}</span>
    </p>
  </div>
</template>

<script>
import { prependUsdSign } from "@/utils";

export default {
  name: "MenuItemInfo",
  props: {
    menuItem: Object,
    itemPrice: [String, Number]
  },
  data: function () {
    return {
      caloriesLabel: this.menuItem?.caloriesLabel || "cal"
    };
  },
  computed: {
    displayCalories() {
      return !!this.menuItem?.calories || this.menuItem?.calories === 0;
    },
    isDescriptionVisible() {
      return !!this.menuItem?.showDesc && !!this.menuItem?.description;
    }
  },
  methods: {
    prependUsdSign
  }
};
</script>

<style lang="scss" scoped>
.menu-item-info {
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__calories {
    margin-left: 16px;
    color: $group-3-color-3;
    font-weight: 300;
  }

  &__description {
    flex-basis: 100%;
    color: $group-3-color-3;
    font-size: 14px;
  }

  &__price {
    flex-basis: 100%;
    font-size: 16px;
    font-weight: bold;
    color: $group-3-color-4;
  }
}
</style>
